function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEllipse = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  className: "bi bi-egg",
  viewBox: "0 0 16 16",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  style: {
    color: "#000000",
    fill: "#000000",
    strokeLinecap: "round",
    InkscapeStroke: "none"
  },
  d: "M 8,0 C 6.2968982,0 4.7740242,0.94534489 3.7070313,2.4003906 2.6400383,3.8554364 2,5.8299186 2,8 2,10.170081 2.6400383,12.144564 3.7070313,13.599609 4.7740242,15.054655 6.2968982,16 8,16 9.7031018,16 11.225976,15.054655 12.292969,13.599609 13.359962,12.144564 14,10.170081 14,8 14,5.8299186 13.359962,3.8554364 12.292969,2.4003906 11.225976,0.94534489 9.7031018,0 8,0 Z m 0,1.0019531 c 1.3340278,0 2.561046,0.7330539 3.484375,1.9921875 C 12.407704,4.2532742 12.998047,6.0283834 12.998047,8 c 0,1.9716166 -0.590343,3.746726 -1.513672,5.005859 C 10.561046,14.264993 9.3340278,14.998047 8,14.998047 c -1.3340278,0 -2.5610455,-0.733054 -3.484375,-1.992188 C 3.5922955,11.746726 3.0019531,9.9716166 3.0019531,8 3.0019531,6.0283834 3.5922955,4.2532742 4.515625,2.9941406 5.4389545,1.735007 6.6659722,1.0019531 8,1.0019531 Z",
  id: "path2"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEllipse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ellipse.580445a23a4791fe0ea94f985b189850.svg";